// Used to identify which transaction class we are dealing with when it has been converted to a generic object.
const CloverTransactionClassName = Object.freeze({
    PAYMENT: 'PAYMENT',
    REFUND: 'REFUND',
    VOID: 'VOID',
});

module.exports = CloverTransactionClassName;
